module.exports = __webpack_public_path__ + "static/media/rep.cfc948f8.svg";